import { _ as _toConsumableArray } from '../../dist/toConsumableArray-5ba6766a.browser.esm.js';
import React from 'react';
import { jsx } from 'react/jsx-runtime';
import '../../dist/unsupportedIterableToArray-0ac4ac41.browser.esm.js';

/**
 * Render RichText using JSX
 *
 * @example
 * const content = useVal(contentVal);
 * return <ValRichText>{content.myRichText}</ValRichText>
 *
 * @example
 * const content = useVal(contentVal);
 * return (
 *   <ValRichText
 *     theme={{
 *       h1: 'text-4xl font-bold',
 *     }}>
 *    {content.myRichText}
 *   </ValRichText>
 * );
 *
 *
 * @example
 * const content = useVal(contentVal);
 * return (
 *   <ValRichText
 *     theme={{
 *        block: {
 *          h1: 'text-4xl font-bold',
 *        },
 *        inline: {
 *          img: 'rounded',
 *        }
 *     }}
 *     transform={(node, className) => {
 *        if (node.tag === 'img') {
 *          return <Image className={className} src={node.src} alt={node.alt || ""} width={node.metadata?.width} height={node.metadata?.height} />
 *        }
 *     }}>
 *    {content.myRichText}
 *   </ValRichText>
 * );
 *
 * @param
 * @returns
 */
function ValRichText(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    theme = _ref.theme,
    transform = _ref.transform;
  var root = children;
  function build(child, key) {
    if (typeof child === "string") {
      var transformed = transform && transform(child, []);
      if (transformed !== undefined) {
        return transformed;
      }
      return child;
    }
    var className = classNameOfTag(child.tag, child.tag === "span" ? child.styles : [], theme);
    if (child.tag === "img") {
      var _child$src$metadata, _child$src$metadata2;
      var _transformed = transform && transform(child, []);
      if (_transformed !== undefined) {
        return _transformed;
      }
      return /*#__PURE__*/React.createElement("img", {
        key: key === null || key === void 0 ? void 0 : key.toString(),
        className: className,
        src: child.src.url,
        // alt: child.alt, TODO: add alt to the img html object
        width: (_child$src$metadata = child.src.metadata) === null || _child$src$metadata === void 0 ? void 0 : _child$src$metadata.width,
        height: (_child$src$metadata2 = child.src.metadata) === null || _child$src$metadata2 === void 0 ? void 0 : _child$src$metadata2.height
      });
    }
    var children = "children" in child ?
    // Why do this? We get a very weird error in NextJS 14.0.4 if we do not
    // Error: Cannot access Image.prototype on the server. You cannot dot into a client module from a server component. You can only pass the imported name through.
    // https://github.com/vercel/next.js/issues/52415
    child.children.length === 1 ? build(child.children[0]) : child.children.map(build) : null;
    if (transform) {
      var _transformed2 = transform(child, children !== null && children !== void 0 ? children : [], className);
      if (_transformed2 !== undefined) {
        return _transformed2;
      }
    }
    var tag = child.tag; // one of:  "a" | "ul" | "ol" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "br" | "p" | "li" | "span"
    return /*#__PURE__*/React.createElement(tag, {
      key: key === null || key === void 0 ? void 0 : key.toString(),
      className: className,
      children: children,
      href: child.tag === "a" ? child.href : undefined
    });
  }
  return /*#__PURE__*/jsx("div", {
    className: className,
    style: style,
    "data-val-path": root.valPath,
    children: root.map(build)
  });
}
function classNameOfTag(tag, style, theme) {
  var thisTagClassName = null;
  if (theme && tag in theme) {
    var _tag;
    thisTagClassName = (_tag = theme[tag]) !== null && _tag !== void 0 ? _tag : null;
  }
  return [].concat(_toConsumableArray(thisTagClassName ? [thisTagClassName] : []), _toConsumableArray(style.map(function (style) {
    if (theme &&
    // not need on type-level, but defensive on runtime:
    typeof style === "string") {
      if (style === "line-through") {
        if ("lineThrough" in theme) {
          return theme["lineThrough"];
        }
      }
      if (style !== "line-through" && style in theme) {
        return theme[style];
      }
    }
    return style;
  }))).join(" ");
}

export { ValRichText };
